import { Card } from 'react-bootstrap';
import {
  DoctorProviderIconSVG,
  FacilityProviderIconSVG,
} from '../../img/uploadDocument/uploadDocumentSVG';
import { EditSVG } from 'src/Admin/img/Admin/ProviderSelfRegistration/ProviderRegistration';
import './ProviderRegistration.scss';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../../api/axios';
import APIEndpoints from '../../api/APIEndpoints';
import { ToastContainer, toast } from 'react-toastify';
import { HttpSuccessCodes } from '../../errorhandling/HttpErrorCodes';
import ToastMessage from '../common/ToastMessage';

const ReviewUserProfile = ({
  providerType,
  userFormData,
  formData,
  facilityFormData,
  providerFlowResponse,
  approvalRequiredFlag,
}) => {
  const navigate = useNavigate();
  const payloadDoctor = {
    AddUser: {
      UserType: 'Provider',
      UserProviderAffiliationDetails: [
        {
          FacilityOid: providerFlowResponse?.FacilityOId,
          PhysicianData: [
            {
              PhysicianOid: providerFlowResponse?.PhysicianOid,
              ConnectorId: providerFlowResponse?.ConnectorID,
            },
          ],
        },
      ],

      UserID: userFormData?.email,
      LastName: userFormData?.lastName,
      ConfirmEmail: userFormData?.confirmEmail,
      FirstName: userFormData?.firstName,
      MiddleName: userFormData?.middleName,
      Comments: userFormData?.Comments,
      ProviderSelfRegister: true,
      IsDoctorFacility: true,
    },
  };
  const payloadFacility = {
    AddUser: {
      UserType: 'Provider',
      UserProviderAffiliationDetails: [
        {
          FacilityOid: providerFlowResponse?.FacilityOId,
          PhysicianData: [],
        },
      ],

      UserID: userFormData?.email,
      LastName: userFormData?.lastName,
      ConfirmEmail: userFormData?.confirmEmail,
      FirstName: userFormData?.firstName,
      MiddleName: userFormData?.middleName,
      Comments: userFormData?.Comments,
      ProviderSelfRegister: true,
      IsDoctorFacility: false,
    },
  };
  const nextSuccessPage = async () => {
    try {
      const createProvider = await axiosInstance.post(
        approvalRequiredFlag
          ? APIEndpoints.postCreateProviderWithApproval()
          : APIEndpoints.getCreateAllUserTypesAPIResource(),

        providerType === 'Doctor' ? payloadDoctor : payloadFacility,
      );
      const createDoctorFacility = approvalRequiredFlag
        ? createProvider
        : createProvider?.data?.Response;
      if (
        createDoctorFacility.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        navigate('/admin/provider-self-registration/success');
      }
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle="Something went wrong, please try again after some time."
        />,
      );
    }
  };

  const userName =
    (userFormData.firstName || '') +
    ' ' +
    (userFormData.middleName || '') +
    ' ' +
    (userFormData.lastName || '');

  let doctorName;
  if (providerType === 'Doctor') {
    doctorName =
      (formData.physiciansfirstname || '') +
      ' ' +
      (formData.physicianslastname || '');
  } else {
    doctorName =
      (facilityFormData.PhysiciansFirstName || '') +
      ' ' +
      (facilityFormData.PhysiciansLastName || '');
  }

  const Specialty =
    providerFlowResponse?.PhysicianDetails?.doctortype &&
    providerFlowResponse?.PhysicianDetails?.doctortype
      .split(',')
      .map((item) => item.trim());
  console.log(Specialty, 'Specialty');

  return (
    <>
      <div className="pt-2 review-information">
        <div className="review-yor-info">Review your profile information</div>
        <div className="pt-4">
          <Card className="doctor-facility-info-card">
            <div className="d-flex flex-1 align-items-center">
              <div className="">
                {providerType === 'Doctor' ? (
                  <DoctorProviderIconSVG className="document_providericonsvg" />
                ) : (
                  <FacilityProviderIconSVG className="document_providericonsvg" />
                )}
              </div>
              <div className="pl-3 ">
                <div>
                  <span className="doc-fac-name">
                    {providerType === 'Doctor'
                      ? providerFlowResponse?.PhysicianDetails?.firstname +
                        ' ' +
                        providerFlowResponse?.PhysicianDetails?.middlename +
                        ' ' +
                        providerFlowResponse?.PhysicianDetails?.lastname
                      : providerFlowResponse?.FacilityDetails?.facilityname}
                  </span>
                </div>
                <div className="d-flex">
                  <div className="specility-info">
                    {providerType === 'Doctor' ? (
                      <>
                        {Specialty[0] && <span>{Specialty[0]}</span>}
                        {Specialty[1] && <span>, {Specialty[1]}</span>}

                        {Specialty.length > 2 && (
                          <span> +{Specialty.length - 2}</span>
                        )}
                      </>
                    ) : (
                      providerFlowResponse?.FacilityDetails?.speciality
                    )}{' '}
                  </div>
                  {providerType === 'Doctor' &&
                    providerFlowResponse?.PhysicianDetails?.doctortype && (
                      <span className="pl-1 pr-1"> | </span>
                    )}
                  <div className="specility-info">
                    Tax ID :{' '}
                    {providerType === 'Doctor'
                      ? providerFlowResponse?.Facility?.taxId
                      : providerFlowResponse?.FacilityDetails?.taxid}
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card className="mt-4 provider-userinfo-card">
            <div className="d-flex justify-content-between">
              <div className="user-info-title">User Profile Information</div>
              <div>
                <EditSVG className="edit_providericonsvg" />
              </div>
            </div>
            <div className="d-flex flex-column">
              <div className="d-flex pt-4 justify-content-between">
                <div className="d-flex flex-column">
                  <div className="userinfo-title">User Name</div>
                  <div className="userinfo">{userName}</div>
                </div>
                <div className="d-flex flex-column">
                  <div className="userinfo-title">Email</div>
                  <div className="userinfo"> {userFormData?.email}</div>
                </div>
              </div>
              <div className="pt-5">
                <div className="userinfo-title">User Type</div>
                <div className="userinfo">
                  {' '}
                  {providerType === 'Doctor' ? 'Provider' : 'Facility'}
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="pt-4 submit-button">
          <GenericButton
            className="ml-1"
            type="submit"
            onClick={() => nextSuccessPage()}
          >
            SUBMIT
          </GenericButton>
        </div>
      </div>
    </>
  );
};

export default ReviewUserProfile;
